import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import InvoiceAutomationRunList from './InvoiceAutomationRunList';
import InvoiceAutomationExcludedJobList from './InvoiceAutomationExcludedJobList';

// The History of a project's automatic invoicing, in one card: its runs, and the jobs taken off its drafts.
export default function InvoiceAutomationHistory({ projectId = null, projectName = '', clientId = null }) {
  const tabs = [
    {
      label: 'Runs',
      id: 'runs',
      icon: 'fa-solid fa-clock-rotate-left',
      component: (
        <InvoiceAutomationRunList
          projectId={projectId}
          projectName={projectName}
          clientId={clientId}
        />
      ),
    },
    {
      label: 'Jobs Taken Off',
      id: 'jobs_taken_off',
      icon: 'fa-solid fa-ban',
      component: <InvoiceAutomationExcludedJobList projectId={projectId} />,
    },
  ];

  return (
    <TabbedPage
      className='iauto-history'
      tabs={tabs}
      onTabChange={() => {}}
    />
  );
}
